import Button from './component';
import * as ButtonVariants from './component';

export default Button;

export const ButtonBlackMedium = ButtonVariants.BlackMedium;
export const ButtonWhiteMediumArrowL = ButtonVariants.WhiteMediumArrowL;
export const ButtonWhiteMediumArrowR = ButtonVariants.WhiteMediumArrowR;
export const ButtonWhiteXSmallArrowL = ButtonVariants.WhiteXSmallArrowL;
export const ButtonWhiteXSmallArrowR = ButtonVariants.WhiteXSmallArrowR;
export const ButtonInputClear = ButtonVariants.InputClear;
export const ButtonPagingSwitch = ButtonVariants.PagingSwitch;
export const ButtonPagingSwitchEllipsis = ButtonVariants.PagingSwitchEllipsis;
export const ButtonWhiteXLargeArrowL = ButtonVariants.WhiteXLargeArrowL;
export const ButtonWhiteXLargeArrowR = ButtonVariants.WhiteXLargeArrowR;
export const ButtonBlackPurpleMedium = ButtonVariants.BlackPurpleMedium;
export const ButtonGreenWhiteFlashMedium = ButtonVariants.GreenWhiteFlashMedium;
export const ButtonWhiteMedium = ButtonVariants.WhiteMedium;
export const ButtonWhitePurpleXSmallFilter =
	ButtonVariants.WhitePurpleXSmallFilter;
export const ButtonWhitePurpleResponsiveFilter =
	ButtonVariants.WhitePurpleResponsiveFilter;
export const ButtonWhiteRedXXSmall = ButtonVariants.WhiteRedXXSmall;
export const ButtonPurpleMedium = ButtonVariants.PurpleMedium;
export const ButtonTransparentRedMedium = ButtonVariants.TransparentRedMedium;
export const ButtonBlackLargeClose = ButtonVariants.BlackLargeClose;
export const ButtonWhitePurpleSmall = ButtonVariants.WhitePurpleSmall;
